import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupDCT from "../FieldTags/GroupDCT";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const DatasetsValidationLink = ({ datasetsValidationLink, handleChange, pullLists, informedConsent, informedConsentApprover, shipmentFromRepo, sampleDisposal }) => {
    const { user } = useContext(UserContext);
    const canEdit = ((shipmentFromRepo === "No" && sampleDisposal === "No") || (informedConsent !== "No" && informedConsentApprover !== "No")) && checkRole(user, [ROLES.DCT]);

    return (
        <div className="planField">
            <GroupDCT />
            <TextField
                id="datasetsValidationLink-field"
                name="datasetsValidationLink"
                label={pullListLabels.datasetsValidationLink}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={datasetsValidationLink ? datasetsValidationLink : ""}
                onChange={(e) => handleChange("datasetsValidationLink", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            <HistoryLogElement pullLists={pullLists} label={"datasetsValidationLink"} />
        </div>
    );
};

export default DatasetsValidationLink;